function pickFirstNonEmpty(...values) {
  for (const value of values) {
    if (value == null) continue;
    const s = String(value).trim();
    if (s) return s;
  }
  return null;
}

/** Requestor / RFQ owner contact shown to logistics providers on quote pages. */
export function resolveLogisticsRfqRequestorInfo(rfq) {
  if (!rfq || typeof rfq !== 'object') {
    return { name: '—', roleLabel: null, contactNumber: '—', email: '—' };
  }

  const allocator = rfq.allocator && typeof rfq.allocator === 'object' ? rfq.allocator : null;
  if (allocator) {
    return {
      name: pickFirstNonEmpty(allocator.name) || '—',
      roleLabel: pickFirstNonEmpty(allocator.roleLabel) || null,
      contactNumber: pickFirstNonEmpty(allocator.phone) || '—',
      email: pickFirstNonEmpty(allocator.email) || '—',
    };
  }

  const payload = rfq.payload && typeof rfq.payload === 'object' ? rfq.payload : {};
  const name = pickFirstNonEmpty(
    payload.contactPerson,
    payload.contact_person,
    payload.companyName,
    payload.company_name,
  );
  const company = pickFirstNonEmpty(payload.companyName, payload.company_name);
  const contactNumber = pickFirstNonEmpty(
    payload.contactNumber,
    payload.contact_number,
    payload.phone,
    payload.mobile,
  );
  const email = pickFirstNonEmpty(payload.companyEmail, payload.company_email, payload.email);

  return {
    name: name || '—',
    roleLabel: company && name && company !== name ? company : company ? 'Requestor' : null,
    contactNumber: contactNumber || '—',
    email: email || '—',
  };
}
